if (!customElements.get('lp-course-date-picker')) {
  class LPCourseDatePicker extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.nativePicker = this.querySelector('variant-selects');
      this.addEventListener('change', this.onChange = (event) => {
        if (event.target.matches('[data-lp-date-select]')) {
          const input = this.radios.find((radio) => radio.value === event.target.value);
          if (!input) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (event.target.matches('input[type="radio"]')) this.syncSelection();
      });
      this.observer = new MutationObserver((records) => {
        if (records.some(({ target }) => target === this || target.closest?.('variant-selects'))) this.refresh();
      });
      this.observer.observe(this, { childList: true, subtree: true });
      this.refresh();
      this.dataset.enhanced = '';
      this.querySelector('[data-lp-more]')?.removeAttribute('hidden');
      this.querySelector('[data-lp-selection]')?.removeAttribute('hidden');
      queueMicrotask(() => {
        const selected = this.radios.find((radio) => radio.checked);
        const variantInput = document.getElementById(selected?.getAttribute('form'))?.querySelector('input[name="id"]');
        if (selected && variantInput && variantInput.value !== selected.dataset.variantId) {
          selected.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    get radios() { return Array.from(this.querySelectorAll('variant-selects input[type="radio"]')); }
    refresh() {
      const radios = this.radios;
      if (radios.length && !radios.some((radio) => radio.checked)) radios[0].checked = true;
      const select = this.querySelector('[data-lp-date-select]');
      if (select) {
        select.replaceChildren(new Option(this.dataset.placeholder, ''));
        radios.filter((radio) => radio.hasAttribute('data-lp-extra')).forEach((radio) => {
          select.add(new Option(radio.value, radio.value));
        });
      }
      if (!radios.length) {
        const productInfo = this.closest("product-info");
        productInfo?.querySelector("button[name=add]")?.setAttribute("disabled", "");
        productInfo?.querySelector("input[name=id]")?.setAttribute("disabled", "");
      }
      this.syncSelection();
    }
    syncSelection() {
      const checked = this.radios.find((radio) => radio.checked);
      const select = this.querySelector('[data-lp-date-select]');
      if (select) select.value = checked?.hasAttribute('data-lp-extra') ? checked.value : '';
      const summary = this.querySelector('[data-lp-selected-text]');
      if (summary && summary.textContent !== (checked?.value || '')) summary.textContent = checked?.value || '';
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('change', this.onChange);
      this.initialized = false;
    }
  }
  customElements.define('lp-course-date-picker', LPCourseDatePicker);
}
